import React from 'react';
import LicenseMultiSelectField from '../LicenseMultiSelectField';
/**
 * Trade picker for the three license editors: the inspections Assets tree,
 * wired to a Rails array parameter (IP-15528).
 *
 * Unlike the State picker this one is hierarchical and passes
 * `nonSelectableValues`, because `TradeOptions::CONTAINER_KEYS`
 * (`assets`/`components`/`equipment`) group device types rather than being
 * licensable trades themselves (IP-15145).
 */
function TradeTreeField({ name, label, initialValue = [], options, nonSelectableValues = [], emptyHint }) {
    return (React.createElement(LicenseMultiSelectField, { name: name, label: label, initialValue: initialValue, options: options, nonSelectableValues: nonSelectableValues, emptyHint: emptyHint, className: "license-trade-tree-field" }));
}
export default TradeTreeField;
